import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { LocalStateSettings } from '../state';

export const updatePresetSettings = async (
  { rootState, state, commit, dispatch }: SafeAny,
  updateSettings: NonNullable<any>
) => {
  const url = `${rootState.env?.requestUrl.events}/user`;
  const { selectedPresetId, name, isSelectedPresetChange, isNewPreset } = updateSettings;

  state.settings = {
    ...state.settings,
    isLoading: true,
    error: undefined
  };

  let payload;

  if (isSelectedPresetChange) {
    payload = {
      selectedPresetId
    };
  } else {
    const presets = [...state.settings.presets];
    const index = isNewPreset ? -1 : presets.findIndex((p) => p.name === name);

    const basePreset = index >= 0 ? presets[index] : { ...state.settings.presets[0] };
    const presetId = isNewPreset ? Date.now() : selectedPresetId;

    const presetToSave = {
      ...basePreset,
      id: presetId,
      name,
      signalsList: state.settings.signalsList,
      hypnogramFullNightSignals: state.settings.hypnogramFullNightSignals,
      signalHeight: state.settings.signalHeight.toString() || 'auto',
      band: state.settings.band,
      notch: state.settings.notch
    };

    if (index >= 0) {
      presets[index] = presetToSave;
    } else {
      presets.push(presetToSave);
    }

    payload = {
      selectedPresetId: presetId,
      presets
    };
  }

  try {
    await axiosInstance
      .patch<LocalStateSettings>(url, payload)
      .then((response) => {
        commit('setSettingsFromAPI', response.data);
      })
      .catch(() => {
        dispatch('epoch/getPresetSettings');
      });
  } catch (error: SafeAny) {
    Object.assign(state.settings, {
      isLoading: false,
      presets: [],
      error
    });

    commit(
      'addNotification',
      {
        i18nTitle: 'fetchError',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
